import(/* webpackMode: "eager" */ "/var/www/proflow360/src/app/not-found.tsx");
